<template>
  <div class="history-list-wrapper">
    <div class="title">
      <div style="display: flex;align-items: center;">
        <i class="title-icon iconfont icon-iconset0194"></i>
        <span class="title-label">治疗信息摘要</span>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      size="small"
      @row-click="chooseTableItem"
      style="width: 100%; font-size:14px; font-weight:600; height: calc(100% - 80px); background-color: rgb(239,243,247)"
    >
      <el-table-column prop="idx" label="" width="34px"></el-table-column>
      <el-table-column prop="module_name" label="治疗模块/药物" width="120px"></el-table-column>
      <!-- <el-table-column prop="param_value" label="治疗参数/用法用量" width="200px" show-overflow-tooltip></el-table-column> -->
      <el-table-column prop="param_value" label="治疗参数/用法用量"      show-overflow-tooltip></el-table-column>
    </el-table>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  // import api from '../api';
  // import axios from 'axios';
  // import csrftoken from "../getToken";
  // import Util from "../utils/utils.js";
  import _ from "lodash";
  import moment from 'moment';
  let that;
  
  export default {
    
    inject: {
      commonData: ['commonData'],
    },
    
    data() {
      return {
        // 历史列表数据
        tableData: [],
        form:{}
      }
    },
    
    methods: {
      // 查询参数编号数据
      async getOperationParaDigest() {
        try {
          const res = await this.$apollo.query({
            query: gql`query(
              $patient_id: Int!
              $treat_no: String!
            ){
              getCosmetologyReleInfo(
                patient_id: $patient_id
                treat_no: $treat_no
              ){
                id
                treat_details{
                  id
                  item_id
                  device_id
                  module_id
                  module_info{
                   id
                   module_name
                  }
                  param_value
                  detail_title
                }
              }
            }`,
            fetchPolicy: "no-cache",
            variables: {
              patient_id: this.commonData.patientId,
              treat_no: this.commonData.treat_no,
            },
          });
          const parNumsArr = res.data.getCosmetologyReleInfo.treat_details;
          
          if (parNumsArr.length) {
            let idx = 1;
            for (const item of parNumsArr) {
              // item.number = item.detail_title;
              // item.isActive = false;
              item.module_name = item.module_info.module_name;
              let new_para = ""
              // console.log("parNumsArr:",item);
              let raw_para_value = JSON.parse(item.param_value);
              let i = 0;
              for (const para of raw_para_value) {
                if(i<raw_para_value.length-1){
                  new_para += para.label + ":" + para.value + "; ";
                }else{
                  new_para += para.label + ":" + para.value
                }                
                i +=1 ;
              }
              item.param_value = new_para;
              // 序号
              item.idx = idx;
              idx += 1;            

            }
            this.tableData = parNumsArr;
          } else {            

          }

          // console.log("getOperationParaDigest:",this.tableData);
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
          // console.log("error,getOperationParaDigest:",error)
        }
      },

      chooseTableItem(row, column, event) {
        // console.log("In chooseTableItem,row id:",row.id);
      },

    },
    
    async mounted() {
      this.$root.$on('refreshCosmetParaDigest', async () =>  {
       // console.log("In commonHairdressingDigest, on refreshCosmetParaDigest, begin getList");
        this.getOperationParaDigest();
      });
      // 循环查询后台数据库，获取治疗模块摘要信息;
      this.timer = setInterval( () => {
        if (this.commonData.patientId > -1) {
          // clearInterval(this.timer);
          this.getOperationParaDigest();
        }
      }, 4000);
    },
    
    beforeDestroy() {
      this.$root.$off('refreshCosmetParaDigest');
      clearInterval(this.timer);
    },
  
  }
</script>

<style lang="less">
  .history-list-wrapper .el-table__body-wrapper{
    height: calc(100% - 40px);
    overflow-y: auto;
  }
  .history-list-wrapper .el-table th{
    color: #61a2bf !important;
    background-color: inherit !important;
    font-weight: bold !important;
  }
  .history-list-wrapper .el-table tr{
    background-color: inherit !important;
  }
  .history-list-wrapper .cell{
    word-break: break-word !important;
    text-align: center !important;
  }

</style>
<style lang="less" scoped>
  .history-list-wrapper{
    height: 100%;
    padding: 0 5px;
    .title {
      display: flex;
      justify-content: space-between;
      width: 100%;
      color: #48a3c2;
      font-size: 18px;
      font-weight: 500;
      border-bottom: 2px solid #48a3c2;
      padding-top: 10px;
      padding-bottom: 10px;
      margin-bottom: 10px;
      overflow: hidden;
      height: 25px;
      text-align: left;
      align-items: center;
      .title-icon{
        font-size:24px;
        margin-right:10px;
      }
      .title-label{
        white-space: nowrap;
        font-size: 18px;
      }
    }
  }
  .mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }
  .table-item{
    overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
  }
</style>
